
import './App.css';
import Footer from './Components/Footer/Footer';
import Navbar from './Components/Navbar/Navbar';
import Router from './Components/Router';
import 'bootstrap/dist/css/bootstrap.min.css';
// import Construction from './Pages/Construction';

function App() {
  return (
    <div className="" style={{overflowX: 'hidden'}}>
      <Navbar />
      <Router />
      <Footer />

      {/* <Construction /> */}
    </div>
  );
}

export default App;
